var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":'https://s3.eu-west-1.amazonaws.com/php.jilster.nl/' + _vm.app_status + '_magazinepages/' + _vm.magazineId + '/pdf_screen/' + _vm.magazinepageId + '.pdf',"target":"_blank"}},[_c('i',{class:`icon-download-digital downloadDocument`})])
}
var staticRenderFns = []

export { render, staticRenderFns }